module.exports = __webpack_public_path__ + "static/media/img-ccus-explain_owner.276d7e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ccus-explain_owner.png
// module id = 13414
// module chunks = 0